import { Component } from '@angular/core';

@Component({
  selector: 'app-push-notification-landing',
  templateUrl: './push-notification-landing.component.html',
  styleUrls: ['./push-notification-landing.component.scss']
})
export class PushNotificationLandingComponent {

}
